import { lazy } from "react"

const ProductCategoryListing = lazy(() => import("../pages/ContentManagement/ProductCategory/index"))
const AddProductCategory = lazy(() => import("../pages/ContentManagement/ProductCategory/Add/index"))
const EditProductCategory = lazy(() => import("../pages/ContentManagement/ProductCategory/Edit/index"))
const ProductListing = lazy(() => import("../pages/ContentManagement/Product/index"))
const AddProduct = lazy(() => import("../pages/ContentManagement/Product/Add/index"))
const EditProduct = lazy(() => import("../pages/ContentManagement/Product/Edit/index"))

const cmsRoutes = [
  { path: "/cms/product-category", component: ProductCategoryListing, userAccessLevel: 1000},
  { path: "/cms/add-product-category", component: AddProductCategory, userAccessLevel: 1000},
  { path: "/cms/edit-product-category/:id", component: EditProductCategory, userAccessLevel: 1000},
  { path: "/cms/products", component: ProductListing, userAccessLevel: 1000},
  { path: "/cms/add-product", component: AddProduct, userAccessLevel: 1000},
  { path: "/cms/edit-product/:id", component: EditProduct, userAccessLevel: 1000},
]

export default cmsRoutes;